import React from 'react';
import { useGame } from 'common/state';

function Toast() {
  const [gameState] = useGame();

  const isVisible = gameState.ui.toast !== null;

  if (!isVisible) {
    return null;
  }

  return (
    <div className="toast-wrapper ad-padding">
      <div className="toast">{gameState.ui.toast}</div>
    </div>
  );
}

export default Toast;
